import("./AppBootstrap")
  .then(async ({ renderApp }) => {
    await renderApp();
  })
  .catch(error => {
    console.error("Failed to render the application:", error);
  });

export {};
